import React, { useState } from "react";
import hexagonalShape from "../../assets/img/hexagonal-bg.svg";
import HorizontalScroll from "../common/HorizontalScroll";
import TimelineSlider from "./LineSlider";
import DateInputField from "../common-managment/DateInputField";
import CustomSelect from "../common/CustomSelect";
import { FiSkipBack } from "react-icons/fi";
import { TfiControlPause } from "react-icons/tfi";
import { GrPlay } from "react-icons/gr";
import { AiOutlineSearch } from "react-icons/ai";
import img from "../../assets/img/simulation-drawer-img.png";
import { CalendarIcon } from "../../Icons";

export default function Simulation({ setIsOpenSearchResult }) {
  const [sliderPos, setSliderPos] = useState(25);

  const handlePositionChange = (pos) => {
    setSliderPos(pos);
    console.log(`Position: ${Math.round(pos)}%`);
  };

  const getDateLabel = (pos) => {
    const months = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];
    const monthIndex = Math.round((pos / 100) * 11);
    return `2025-${months[monthIndex]}`;
  };

  const [formData, setFormData] = useState({
    startDate: "2025-08-29",
    process: 431,
    intervalNumber: 1,
    intervalType: "Day",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  return (
    <div className="pb-2.5">
      <div className="p-2.5 border-b border-[#C9C9C9]/30 w-full">
        <HorizontalScroll className="w-full">
          <div className="flex items-center">
            {Array(12)
              .fill("")
              .map((_, idx) => (
                <div
                  key={idx}
                  className="min-w-[215px] max-w-[215px] h-7 relative"
                >
                  {/* background */}
                  <img
                    src={hexagonalShape}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                  {/* text */}
                  <p className="absolute left-0 top-1/2 -translate-y-1/2 text-[#242424] text-[12px] w-full px-4 text-center">
                    2025-00-00 A 설치
                  </p>
                </div>
              ))}
          </div>
        </HorizontalScroll>
      </div>
      {/* progress bar  */}
      <div className="py-1 px-2.5 flex flex-col gap-1 border-b border-[#C9C9C9]/30 pt-6">
        <TimelineSlider
          initialPosition={sliderPos}
          onPositionChange={handlePositionChange}
          dateLabel={getDateLabel(sliderPos)}
        />

        <div className="text-center text-[#242424] text-[12px] font-light flex items-center justify-between">
          <p className="">2025-12-01</p>
          <p className="">2025-12-01</p>
        </div>
      </div>
      {/* action area  */}
      <div className="p-2.5 flex items-center justify-between flex-wrap-reverse gap-1.5">
        {/* left side or select type item  */}

        <div className="flex items-center flex-wrap-reverse gap-y-3 gap-[100px]">
          <div className="flex items-center flex-wrap gap-y-1.5 gap-7">
            {/* date  */}
            <div className="flex items-center gap-2.5">
              <h6 className="text-[#212121] text-[12px] font-normal whitespace-nowrap">
                시작 일자 :
              </h6>
              <DateInputField
                value={formData.startDate}
                className="border-[#C9C9C9]/70 bg-white text-sm"
                onChange={(val) => handleChange("startDate", val)}
              />
              <CalendarIcon />
            </div>
            {/* Selection process: */}
            <div className="flex items-center gap-2.5">
              <h6 className="text-[#212121] text-[12px] font-normal whitespace-nowrap">
                선택 공정 :
              </h6>
              <CustomSelect
                label="태그"
                value={formData.process}
                options={[431, 432, 433]}
                onSelect={(val) => handleChange("process", val)}
                className="text-left min-w-[117px]"
                isSearching={true}
              />
            </div>
            {/* Progress interval:*/}
            <div className="flex items-center gap-2.5">
              <h6 className="text-[#212121] text-[12px] font-normal whitespace-nowrap">
                진행 간격 :
              </h6>
              <input
                value={formData.intervalNumber}
                onChange={(e) => handleChange("intervalNumber", e.target.value)}
                className="bg-white outline-none px-2.5 py-[5px] rounded-[4px] max-w-12 min-w-2.5 text-[12px] text-[#242424] border border-[#C9C9C9]/70"
              />
              <CustomSelect
                label="태그"
                value="Day"
                options={["Day", "Week", "Month"]}
                //   onSelect={(val) => handleChange("dev_type", val)}
                className="text-left min-w-[117px] text-[12px]"
                isSearching={true}
              />
            </div>
          </div>

          <div className="flex items-center gap-1.5 justify-center ">
            <button className="aspect-square bg-white flex items-center justify-center border border-[#C9C9C9] p-1.5 rounded-[4px]">
              <FiSkipBack color="#242424" size={14} />
            </button>
            <button className="aspect-square bg-white flex items-center justify-center border border-[#C9C9C9] p-1.5 rounded-[4px]">
              <GrPlay color="#242424" size={12} />
            </button>
            <button className="aspect-square bg-white flex items-center justify-center border border-[#C9C9C9] p-1.5 rounded-[4px]">
              <TfiControlPause color="#242424" size={14} />
            </button>
            <button className="aspect-square bg-white flex items-center justify-center border border-[#C9C9C9] p-1.5 rounded-[4px] rotate-180">
              <FiSkipBack color="#242424" size={14} />
            </button>
          </div>
        </div>
        <div className="flex-1 flex justify-end">
          <button className="" onClick={() => setIsOpenSearchResult(true)}>
            <AiOutlineSearch color="#242424" size={16} />
          </button>
        </div>
      </div>

      {/* table and atab  */}
      <div className="px-2.5">
        <HorizontalScroll className="w-full" isShowScrollBar={true}>
          <div className=" flex items-start gap-2.5">
            {/* table  */}
            <div className="w-[52%] min-w-[600px]">
              <HorizontalScroll className="w-full ">
                <div className="max-h-[220px] overflow-y-auto custom-scrollbar ">
                  {" "}
                  <table className="flex-1 w-full text-[12px] text-[#242424] text-center  whitespace-nowrap relative border border-[#C9C9C9]/30 border-t-0">
                    <thead className="sticky top-0 z-[2]">
                      <tr className="font-normal divide-x divide-[#C9C9C9]/30 bg-[#DBDBDB]">
                        <th className="py-1 px-2.5">IPS</th>
                        <th className="py-1 px-2.5">EMRS</th>
                        <th className="py-1 px-2.5">Description</th>
                        <th className="py-1 px-2.5">계획시작</th>
                        <th className="py-1 px-2.5">계획시작</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                      ].map((_, idx) => (
                        <tr
                          key={idx}
                          className="bg-[#F1F1F1] font-light border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30"
                        >
                          <td className="py-1 px-2.5">50215478521</td>
                          <td className="py-1 px-2.5">52487fjdjhfjdhf 0100</td>
                          <td className="py-1 px-2.5">
                            PLANT CONCAETE FACUTES
                          </td>
                          <td className="py-1 px-2.5">2025-12-01</td>
                          <td className="py-1 px-2.5">2025-12-01</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </HorizontalScroll>
            </div>

            {/* year tab  */}
            <div className="flex-1">
              {/* tab  */}
              <div className="bg-white flex-1 w-full flex items-center justify-between whitespace-nowrap">
                {[2013, 2014, 2015, 2016, 2017, 2018].map((yr, idx) => (
                  <button
                    key={idx}
                    className="px-8 py-[5px] text-[#242424] text-[12px]"
                  >
                    {yr}
                  </button>
                ))}
              </div>

              <img src={img} className="w-full max-h-[258px]" alt="" />
            </div>
          </div>
        </HorizontalScroll>
      </div>
    </div>
  );
}
